export type ClassValue =
  | string
  | number
  | false
  | null
  | undefined
  | ClassValue[];

/**
 * Joins truthy class names into a single space-separated string.
 * Drop-in replacement for the prior clsx + tailwind-merge helper —
 * we no longer need class deduplication now that Tailwind is gone.
 */
export function cn(...inputs: ClassValue[]): string {
  const out: string[] = [];
  const walk = (v: ClassValue) => {
    if (!v && v !== 0) return;
    if (typeof v === "string" || typeof v === "number") {
      out.push(String(v));
    } else if (Array.isArray(v)) {
      for (const item of v) walk(item);
    }
  };
  for (const input of inputs) walk(input);
  return out.join(" ");
}
